import React, { useContext, useEffect,useState } from "react"
import { useLocation } from 'react-router-dom'
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import AlertPermanent from "../core/AlertPermanent"
import ModalMui from "../core/ModalMui"

import AuthContext from "../../context/authentication/authContext"
import PortalContext from "../../context/portal/portalContext"
import ModalContext from "../../context/modal/modalContext"
import ReceiverContext from "../../context/receiver/ReceiverContext"

import useMediaQuery from "../../hooks/useMediaQuery"

//import FiltersCustomers from "./FiltersCustomers"
import CustomersTables from "./CustomersTables"
import ReceiverCreator from '../receivers/ReceiverCreator'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //padding: theme.spacing(3),
    height: "90vw",
  },
  componentTitle: {
    fontSize: "24px",
    color: "#263AE3",
    marginBottom: 15,
  },
}))

const Customers = (props) => {
  const location = useLocation()
  const authContext = useContext(AuthContext);
  const { authenticatedUser } = authContext;

  const modalContext=useContext(ModalContext)
  const { modalShow, showModal, closeModal } = modalContext;
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [type,setType]=useState(props.type)
  const [errorMessage, setErrorMessage]=useState()

  const receiverContext = useContext(ReceiverContext)
  const { error,getReceiver ,setCurrentType} = receiverContext

  useEffect(() => {
      if(error){
        setErrorMessage(error)
       }
    }, [error])

useEffect(() => {
    closeModal()
    const customers = JSON.parse(localStorage.getItem('customers'))
   // getReceiver(customers[0].id,type)
  }, [location])
  useEffect(() => {
    setCurrentType(props.type)
    closeModal()
    if (localStorage.getItem("hasToChange") === "true") {
      props.history.push("/app/change-password?show-terms-of-use=1");
    }
    authenticatedUser();
    const customers = JSON.parse(localStorage.getItem('customers'))
    getReceiver(customers[0].id,props.type)
  }, [])

  const classes = useStyles()
  const isMobile = useMediaQuery("max-width", 600)

  if (errorMessage) {
      return (<AlertPermanent category="error" message={errorMessage} />)
  }
  return (
    <div
      className={classes.root}
      style={{ padding: !isMobile ? "24px" : "0px" }}
    >
        <CustomersTables type={props.type}/>
    </div>
  );
};

export default Customers;
